var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#E6F4FF",
    stroke: "#0D6EFD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1421 13C28.1421 12.4477 27.6944 12 27.1421 12L18.1421 12C17.5899 12 17.1421 12.4477 17.1421 13C17.1421 13.5522 17.5899 14 18.1421 14L26.1421 14V22C26.1421 22.5522 26.5899 23 27.1421 23C27.6944 23 28.1421 22.5522 28.1421 22L28.1421 13ZM13 27.1421L13.7071 27.8492L27.8492 13.7071L27.1421 13L26.435 12.2928L12.2929 26.435L13 27.1421Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUp);
export default __webpack_public_path__ + "static/media/right-up.ffc1bdb1fb388bdce71f16efab4aa9c0.svg";
export { ForwardRef as ReactComponent };